import { BidHistoryProps } from './types';
import { BidHistorySection } from 'pages/Shared/VehicleDetails/components';
import { convertToLocalTime } from 'utils';
import { InfoBlock } from '../InfoBlock';

export const AlternativeOffers = ({ vehicle, initiallyCollapsed }: BidHistoryProps) => {
  const alternativeOfferBids = (vehicle.alternative_bid_offers || []).map((bid: any) => ({
    id: bid.id,
    bid: bid.amount,
    bidder: bid.bidder?.dealership_name,
    date: convertToLocalTime(bid.created_at, true),
    created_at: bid.created_at,
    isExpired: bid.status === 'expired',
    isWithdrawn: bid.status === 'withdrawn'
  }));

  return (
    <InfoBlock>
      <BidHistorySection
        startingBid={vehicle.starting_bid}
        editable={true}
        collapsable={false}
        auctionType={vehicle.auction.type}
        bids={alternativeOfferBids}
        proxyBid={alternativeOfferBids[0]}
        initiallyCollapsed={initiallyCollapsed}
        type="alternativeOffers"
      />
    </InfoBlock>
  );
};
